import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = '@tripvio_visa_checklist_completion_v1';

type TripCompletionMap = Record<string, Record<string, boolean>>;

async function readAll(): Promise<TripCompletionMap> {
  const raw = await AsyncStorage.getItem(STORAGE_KEY);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as TripCompletionMap;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

/**
 * Per-trip visa checklist checkmarks (apply-visa, gather-documents, etc.)
 * so the modal can close/reopen and still show the user's progress.
 */
export async function loadVisaChecklistCompletions(tripId: string): Promise<Record<string, boolean>> {
  if (!tripId) return {};
  try {
    const all = await readAll();
    return all[tripId] ?? {};
  } catch {
    return {};
  }
}

export async function saveVisaChecklistCompletions(
  tripId: string,
  map: Record<string, boolean>
): Promise<void> {
  if (!tripId) return;
  try {
    const all = await readAll();
    all[tripId] = map;
    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    // best-effort only
  }
}
